import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { PageHeader, Kpi } from "@/components/ui-bits";
import { Truck, Clock, CheckCircle2, Users, Route as RouteIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

export default function DriverDashboard() {
  const { user } = useAuth();
  const [stats, setStats] = useState(null);

  useEffect(() => { api.get("/deliveries/dashboard/driver").then(r => setStats(r.data)); }, []);

  return (
    <div data-testid="driver-dashboard">
      <PageHeader
        eyebrow="Driver App"
        title={`Hi, ${user?.name?.split(" ")[0] || "Driver"}`}
        description="Your deliveries for today and overall progress."
        actions={<Link to="/driver/deliveries"><Button className="bg-cobalt-500 hover:bg-cobalt-700 text-white" data-testid="goto-deliveries-btn"><Truck size={14} className="mr-1"/>View Deliveries</Button></Link>}
      />
      {stats && (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4">
          <Kpi testid="driver-kpi-today" label="Today's Deliveries" value={stats.today_deliveries} icon={Truck} accent="cobalt"/>
          <Kpi testid="driver-kpi-pending" label="Pending" value={stats.pending} icon={Clock} accent="amber"/>
          <Kpi testid="driver-kpi-completed" label="Completed" value={stats.completed} icon={CheckCircle2} accent="green"/>
          <Kpi testid="driver-kpi-customers" label="Customers" value={stats.assigned_customers} icon={Users} accent="blue"/>
          <Kpi testid="driver-kpi-routes" label="Routes" value={stats.assigned_routes} icon={RouteIcon} accent="slate"/>
        </div>
      )}
    </div>
  );
}
